// Lib
import React from 'react';

// Components
import Toast from '../../structural/toast/Toast';
import Icon from '../icons/Icon';
import ToastDismissButton from '../../structural/toast/ToastDismissButton';

// Utils
import { useErrorTranslator, type ApiError } from '../../utils/errorTranslation';

// Styles
import './ErrorToast.scss';

type ErrorToastProps = {
    /** The error message to display (legacy string support) */
    message?: string | null;
    /** Error object with errorLocaleKey for translation */
    error?: ApiError | null;
    /** Whether to show the toast */
    show: boolean;
    /**
     * Optional parent container class for modal-aware positioning.
     * When provided, the toast will be positioned relative to the modal instead of the app bottom.
     * Example: "ShareModal", "ImageModal", etc.
     */
    groupId?: string;
    /** Called when the toast is dismissed */
    onDismiss?: () => void;
};

const ErrorToast: React.FC<ErrorToastProps> = ({ message, error, show, groupId, onDismiss }) => {
    const translateError = useErrorTranslator();

    if (!show) {
        return null;
    }

    // Prioritize error object over message string
    const displayMessage = error ? translateError(error) : message;

    return (
        <Toast className="ErrorToast" groupId={groupId}>
            <Icon name="error-alert-round" />
            <span className="ErrorMessage">{displayMessage}</span>
            <ToastDismissButton onClick={onDismiss} />
        </Toast>
    );
};

export default ErrorToast;
